import React from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import ParameterValue from "./components/ParameterValue";
import { resultElementParameterValuesSelector } from "store/rs-workspace/selectors/results.selectors";
import { renderNumberValue } from "utils/string";
import * as styles from "./styles.module.scss";
const ParameterValues = ({ parameter, sources, className }) => {
    const parameterValues = useSelector(resultElementParameterValuesSelector(parameter, sources));
    return (React.createElement("div", { className: classNames(styles.values, className), "data-testid": "parameter-values" }, parameterValues?.map(({ value, targetId, targetName, highlighted }, index) => (React.createElement(ParameterValue, { key: `${targetId}-${targetName}-${index}`, value: (typeof value === "number" ? renderNumberValue(value) : value) ?? "", target: targetName, highlighted: highlighted })))));
};
export default ParameterValues;
